<scitis-app-global-page-header [pageTitle]="'Organization constants'">
  <ng-template #filterElement>
    <button (click)="onAddConstant()"
      [disabled]="(!isAdminRole && !isSuperAdminRole)"
      class="btn btn-primary pull-right">
      <span
      class="fa-solid fa-plus"></span>
      <span class="hidden-xs"
      translate>New organization constant</span>
    </button>
  </ng-template>
</scitis-app-global-page-header>


<div class="card mb-3">
  <div class="card-body">
    <div class="table-responsive-md">
      <table class="table mb-0">
        <thead>
          <tr>
            <th scope="col" class="sortable" sortable="portalSetting.name" (sort)="onColumnSort($event)"><span translate>Name</span>
          </th>
          <th scope="col" class="sortable" sortable="portalSetting.value" (sort)="onColumnSort($event)"><span translate>Type</span>
        </th>
        <th scope="col">
          <div class="row">
            <div class="col-4">
              <span translate>Value</span>
            </div>
            <div class="col-8">
              <span translate>Start</span> /
              <span translate>End</span>
            </div>
          </div>
        </th>
        <th scope="col" class="sortable" sortable="tenantConstant.unit" (sort)="onColumnSort($event)"><span translate>Unit of Measure</span>
      </th>
      <th scope="col" class="sortable " sortable="tenantConstant.decimalPlaces" (sort)="onColumnSort($event)"><span
      translate>Decimal places</span></th>
      <th scope="col" class="text-right"><span translate>Actions</span></th>

    </tr>
  </thead>
  <tbody>
    @for (constant of constants; track constant) {
      <tr>
        <td>
          <strong [innerText]="constant.portalSetting.name"></strong>
        </td>
        <td [innerText]="constant.portalSetting.value"></td>
        <td>
          @for (valueItem of constant.tenantConstant.constantValues; track valueItem) {
            <div class="row my-1 align-items-center"
                 [ngClass]="{
                    'text-success': isActiveInterval(valueItem),
                    'text-black-50': intervalIsInPast(valueItem)
                    }">
              <div class="col-4">
                <span [innerText]="valueItem.value"></span>
                @if (isActiveInterval(valueItem)) {
                  <span class="badge badge-success" translate>active</span>
                }
              </div>
              <div class="col-8">
                <span [innerText]="valueItem.startTimestamp | date:dateTimeFormat"></span>
                &nbsp;<span class="fa-solid fa-chevron-right"></span>&nbsp;
                <span [innerText]="valueItem.endTimestamp | date:dateTimeFormat"></span>
              </div>
            </div>
          }
        </td>
        <td [innerText]="constant.tenantConstant.unit"></td>
        <td [innerText]="constant.tenantConstant.decimalPlaces"></td>
        <td class="text-right">
          <scitis-admin-organization-constant-actions [constants]="constants"
            [portalSettings]="portalSettings"
            [constant]="constant"
            [organizationId]="organizationId"
            [isAdminRole]="isAdminRole"
            [isSuperAdminRole]="isSuperAdminRole">
          </scitis-admin-organization-constant-actions>
        </td>
      </tr>
    }
  </tbody>
</table>
</div>
</div>
</div>
<scitis-page-summary [itemsCount]="constants.length"
  [singleItemText]="translate.instant('Organization constant')"
  [multipleItemsText]="translate.instant('Organization constants')">

</scitis-page-summary>
